// Keep this as a static import. Consumers should statically import
// `asyncDisposable` so these runtime symbols are initialized before any
// transpiled `using` code can run on platforms without native support.
import 'disposablestack/auto';
/**
 * Creates a promise that can be disposed before it settles.
 *
 * Import this function statically so the explicit resource management runtime
 * is initialized before using the returned value with `using` or `await using`.
 */
export const asyncDisposable = (disposableExecutor) => {
    let disposer;
    let resolve;
    let reject;
    const cancel = () => {
        disposer?.();
        disposer = undefined;
    };
    const _resolve = (value) => {
        if (disposer) {
            cancel();
            resolve?.(value);
        }
    };
    const _reject = (reason) => {
        if (disposer) {
            cancel();
            reject?.(reason);
        }
    };
    const promise = new Promise((_resolve, _reject) => {
        resolve = _resolve;
        reject = _reject;
    });
    try {
        disposer = disposableExecutor(_resolve, _reject);
    }
    catch (e) {
        const rejectedPromise = new Promise((_, reject) => reject(e instanceof Error ? e : new Error(String(e))));
        return Object.assign(rejectedPromise, {
            [Symbol.dispose]: () => undefined
        });
    }
    return Object.assign(promise, { [Symbol.dispose]: cancel });
};
